import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './produtoForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
} from './produtoActions';

import {
    getLista as getListaUnidadeMedida
} from '../unidadeMedida/unidadeMedidaActions';

const columns = [
    { field: 'nome', type: 'text' },
    {
        field: 'brinde',
        type: 'text',
        formatter: row => row.brinde ? 'Sim' : 'Não'
    },
    { field: 'nome_unidade_medida', type: 'text' }
];

const Produto = props => {

    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'nome',
        direction: 'asc'
    });

    useEffect(() => {
        props.getLista();
        props.getListaUnidadeMedida();
    }, []);

    const onSort = field => {
        setSort(prev => {
            let direction = 'asc';

            if (prev.field === field) {
                direction = prev.direction === 'asc' ? 'desc' : 'asc';
            }

            return { field, direction };
        });
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '').trim();

        const listaFiltrada = (props.lista || []).filter(item => {
            if (!termoPesquisa) {
                return true;
            }

            const texto = `
                ${item.nome || ''}
                ${item.brinde ? 'sim brinde' : 'nao'}
                ${item.nome_unidade_medida || ''}
                ${item.observacao || ''}
            `.toUpperCase();

            return termoPesquisa
                .toUpperCase()
                .split('+')
                .filter(p => p.trim())
                .every(p => texto.includes(p.trim()));
        });

        return sortData(listaFiltrada, sort, columns);
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item,
                    brinde_formatado: item.brinde ? 'Sim' : 'Não'
                }))}
                name='Produtos'
            >
                <ExcelColumn label='Nome' value='nome' />
                <ExcelColumn label='Brinde' value='brinde_formatado' />
                <ExcelColumn label='Unidade de Medida' value='nome_unidade_medida' />
                <ExcelColumn label='Observação' value='observacao' />
                <ExcelColumn label='Usuário da Inclusão' value='nome_usuario_inclusao' />
                <ExcelColumn label='Usuário da Alteração' value='nome_usuario_alteracao' />
            </ExcelSheet>
        );
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();

        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 260
            : window.innerHeight - 180;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value => setPesquisar(value)}
                        />

                        <div style={{ marginTop: 8, width: 270 }}>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => {
                                    props.setModoTela('cadastro', {});
                                    props.initForm({
                                        brinde: false
                                    });
                                }}
                            >
                                <i className='fas fa-plus'></i> Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => props.getLista()}
                            >
                                <i className='fas fa-sync-alt'></i> Atualizar
                            </button>

                            <ExcelFile
                                filename='Produtos'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{ marginLeft: 2, minWidth: 75 }}
                                    >
                                        <i className='fas fa-file-excel'></i> Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='nome'
                                    label='Nome'
                                    width={300}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='brinde'
                                    label='Brinde'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='nome_unidade_medida'
                                    label='Unidade'
                                    width={180}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='observacao'
                                    label='Observação'
                                    width={300}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <Th sticky alignCenter width={50}></Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, i) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : i % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.nome}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.brinde ? 'Sim' : 'Não'}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.nome_unidade_medida}
                                    </Td>

                                    <Td onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.observacao}
                                    </Td>

                                    <Td alignCenter minWidth={130} maxWidth={130}>
                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible
                                            title='Editar'
                                            event={() => {
                                                props.setModoTela('cadastro', { ...item });
                                                props.initForm({ ...item });
                                            }}
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible
                                            title='Excluir'
                                            event={() => {
                                                props.setModoTela('exclusao', { ...item });
                                                props.initForm({ ...item });
                                            }}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' &&
                renderLista()}
        </Content>
    );
};

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.produto.modoTela,
    aguardando: state.produto.aguardando,
    lista: state.produto.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getListaUnidadeMedida
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Produto);